import React from 'react';
import { Config } from '../config';

export const ConfigContext = React.createContext<Config | undefined>(undefined);

export const ConfigProvider: React.FC<{
    children: React.ReactNode;
    config: Config;
}> = ({ children, config }) => {
    return (
        <ConfigContext.Provider value={config}>
            {children}
        </ConfigContext.Provider>
    );
};
